import React, { Component, Fragment } from "react";
import "./Site.css";
import { Row, Col, Table, Button } from "reactstrap";
import { api, filterHelper, dateHelper } from "../helpers";
import {
  TextFilter,
  FilterSet,
  DateFilter,
  SelectFilter,
  ProductSparkline,
  ProductionDemandDetails,
  ActiveToggleFilter
} from ".";
import "react-datepicker/dist/react-datepicker.css";
import _ from "lodash";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Select from "react-select";
import moment from "moment";
import Alert from "react-s-alert";

const getProductGroups = () =>
  api
    .fetch("Reference/ProductGroups")
    .then(response => {
      var list = response.data;
      if (response.data.length > 0) {
        list.unshift({ id: 0, name: "No product group assigned" });
      }
      list = _.map(list, x => {
        return {
          ...x,
          expanded: true
        };
      });
      return {
        productGroupList: list,
        needProductGroups: list.length > 0 ? false : true
      };
    })
    .catch(x => console.error(x));

const getProductTypes = () =>
  api
    .fetch("Reference/ProductTypes")
    .then(response => {
      var list = response.data;
      if (response.data.length > 0) {
        list = _.map(list, item => {
          item.value = item.id;
          item.label = item.name;
          delete item.id;
          delete item.name;
          return item;
        });
      }
      return {
        productTypeList: list
      };
    })
    .catch(x => console.error(x));

const getLastUploadedShippingDate = () =>
  api
    .fetch("Reference/LastUpdatedShippingDate")
    .then(response => {
      return {
        lastShippingDate: response.data
      };
    })
    .catch(x => console.error(x));

const prepareList = list => {
  var preparedList = _.map(list, item => {
    item.productGroupId =
      item.productGroupId === null ? 0 : item.productGroupId;
    item.productionCountList =
      item.productionCountList !== null
        ? _.map(item.productionCountList.split(","), y => parseInt(y, 10))
        : [];
    item.shippingCountList =
      item.shippingCountList !== null
        ? _.map(item.shippingCountList.split(","), x => parseInt(x, 10))
        : [];
    item.inventoryCountList =
      item.inventoryCountList !== null
        ? _.map(item.inventoryCountList.split(","), z => parseInt(z, 10))
        : [];
    item.dateList =
      item.dateList !== null
        ? _.map(item.dateList.split(","), z => {
            return dateHelper.formatStringDate(z);
          })
        : [];
    item.editing = false;
    return item;
  });
  return preparedList;
};

const sortList = [
  {
    value: 1,
    label: "Supply Level Ascending",
    sortAscending: true,
    sortColumn: "PercentSupplyLevel"
  },
  {
    value: 2,
    label: "Supply Level Descending",
    sortAscending: false,
    sortColumn: "PercentSupplyLevel"
  },
  {
    value: 3,
    label: "Display Order Ascending",
    sortAscending: true,
    sortColumn: "DisplayOrder"
  },
  {
    value: 4,
    label: "Display Order Descending",
    sortAscending: false,
    sortColumn: "DisplayOrder"
  },
  {
    value: 5,
    label: "Days On Hand Ascending",
    sortAscending: true,
    sortColumn: "DaysOnHand"
  },
  {
    value: 6,
    label: "Days On Hand Descending",
    sortAscending: false,
    sortColumn: "DaysOnHand"
  }
];

const resolveSelectedSortValue = (list, sortColumn, sortAscending) => {
  const sortDirection = sortAscending ? "Ascending" : "Descending";
  return _.find(list, item => {
    return (
      item.sortAscending === sortAscending &&
      item.sortColumn === sortColumn &&
      item.label.includes(sortDirection)
    );
  });
};

export default class ProductionDemandReport extends Component {
  static displayName = ProductionDemandReport.name;
  constructor(props) {
    super(props);
    this.state = {
      message: null,
      messageColor: null,
      isMessageVisible: false,
      filters: [],
      pagedList: null,
      productGroupList: [],
      sortColumn: "DisplayOrder",
      sortAscending: true,
      reportDate: moment().toDate(),
      productsRequiringAttention: false,
      needProductGroups: true,
      lastShippingDate: null,
      updatingInventoryCounts: false,
      loading: false
    };
    this.refreshList = this.refreshList.bind(this);
    this.clearFilters = this.clearFilters.bind(this);
    this.onChangeFilter = this.onChangeFilter.bind(this);
    this.setPage = this.setPage.bind(this);
    this.onToggleExpand = this.onToggleExpand.bind(this);
    this.onSelectChange = this.onSelectChange.bind(this);
    this.resolveProductDisplayList = this.resolveProductDisplayList.bind(this);
    this.onToggleGroup = this.onToggleGroup.bind(this);
    this.onMassInventoryCountUpdate = this.onMassInventoryCountUpdate.bind(
      this
    );
  }

  componentDidMount() {
    var apiCallList = [
      getLastUploadedShippingDate(),
      getProductGroups(),
      getProductTypes()
    ];
    Promise.all(apiCallList).then(response => {
      let newStatus = {};
      _.each(response, r => Object.assign(newStatus, r));
      this.setState(newStatus, () => {
        if (!this.state.needProductGroups) {
          let dateToUse =
            new Date(this.state.lastShippingDate) || moment().toDate();
          this.onChangeFilter({
            filterName: "demandReportDate",
            value:
              new Date(this.state.lastShippingDate) || dateHelper.getUtcDate(),
            filteredDisplay: `Demand Report Date: ${dateHelper.getSelectedDate(
              dateToUse,
              "MM/DD/YYYY"
            )}`
          });
        }
      });
    });
  }

  refreshList(sortColumn, sortAscending, filters, pageNumber) {
    this.setState({ loading: true }, ()=>{
    const resolvedFilters = filters || this.state.filters;
    const resolvedSort = {
      sortColumn: sortColumn || this.state.sortColumn,
      sortAscending: sortAscending || this.state.sortAscending
    };
    const payload = {
      activeOnly: null,
      name: null,
      ...resolvedSort,
      ...filterHelper.filtersToObject(resolvedFilters),
      pageSize: 50,
      page:
        pageNumber ||
        (this.state.pagedList ? this.state.pagedList.pageNumber : 1)
    };
    api
      .post("Product/GetDailyProductionDemandReportTotals", payload)
      .then(response => {
        if (response && response.data) {
          this.setState({
            ...resolvedSort,
            pagedList: {
              list: prepareList(response.data.dataSource),
              pageNumber: response.data.page,
              pageSize: response.data.pageSize,
              totalItems: response.data.totalItems,
              totalPages: response.data.totalPages
            },
            filters: resolvedFilters,
            message: null,
            messageColor: null,
            isMessageVisible: false,
            loading: false
          });
        }
      });
  })
  }

  onMassInventoryCountUpdate() {
    this.setState({ updatingInventoryCounts: true });
    const payload = {
      Date: new Date()
    };

    api
      .post("Product/UpdateInventoryCountsManually", payload)
      .then(response => {
        if (response.data.success) {
          Alert.info(
            "Inventory counts are being updated, this process may take awhile. Please be sure to check your filter date and refresh your screen."
          );
          setTimeout(() => {
            this.setState({ updatingInventoryCounts: false });
          }, 30000);
        }
      });
  }

  setPage(page) {
    this.refreshList(null, null, null, page);
  }

  clearFilters() {
    const filters = [];
    this.setState({ filters: filters }, () => {
      this.onChangeFilter({
        filterName: "demandReportDate",
        value: dateHelper.getUtcDate(),
        filteredDisplay: `Demand Report Date: ${dateHelper.getSelectedDate(
          new Date(),
          "MM/DD/YYYY"
        )}`
      });
    });
  }

  onChangeFilter(changedFilter) {
    const filters = filterHelper.getFilters(this.state.filters, changedFilter);
    this.setState({ filters: filters });
    this.refreshList(null, null, filters, 1);
  }

  onToggleExpand(productId) {
    let elist = this.state.pagedList.list.slice();
    const productIndex = _.findIndex(elist, { productId: productId });
    elist[productIndex].expand = !elist[productIndex].expand;
    this.setState({
      pagedList: { ...this.state.pagedList, list: elist }
    });
  }

  onToggleGroup(groupId) {
    let groups = this.state.productGroupList.slice();
    const groupIndex = _.findIndex(groups, { id: groupId });
    groups[groupIndex].expanded = !groups[groupIndex].expanded;
    this.setState({
      productGroupList: groups
    });
  }

  onSelectChange(selection) {
    this.setState(
      {
        sortColumn: selection.sortColumn,
        sortAscending: selection.sortAscending
      },
      () => {
        this.refreshList(
          selection.sortColumn,
          selection.sortAscending,
          null,
          null
        );
      }
    );
  }

  resolveProductDisplayList(list, group) {
    var l = _.filter(list, g => {
      return g.productGroupId === group.id;
    });
    return l.length > 0 ? l : [];
  }

  onAddToProductionPlanning(productId) {
    let list = this.state.pagedList.list.slice();
    let product = _.find(list, p => {
      return p.productId === productId;
    });
    const payload = {
      ProductId: productId,
      DaysOnHand: product.daysOnHand
    };
    api
      .post(`Product/AddProductToProductionPlanning`, payload)
      .then(response => {
        if (response.data && response.data.success) {
          Alert.success("Product was added to production planning.");
        } else {
          Alert.error(
            response.data.message ||
              "An error occurred. Product cannot be added at this time."
          );
        }
      });
  }

  render() {
    return (
      <div>
        <Row className="pageTitle p-2">
          <Col>
            <h4>Daily Demand Report</h4>
          </Col>
          <Col xs="2" className="float-right">
            <Select
              className="pageTitleItem"
              closeMenuOnSelect
              value={resolveSelectedSortValue(
                sortList,
                this.state.sortColumn,
                this.state.sortAscending
              )}
              isMulti={false}
              options={sortList}
              isDisabled={this.state.needProductGroups}
              onChange={e => this.onSelectChange(e)}
            />
          </Col>
        </Row>

        {!this.state.needProductGroups && (
          <Fragment>
            <Row className="mt-1 mt-0">
              <Col className="float-right">
                <Button
                  className="cbdmdPrimary float-right"
                  size="sm"
                  onClick={this.onMassInventoryCountUpdate}
                  disabled={this.state.updatingInventoryCounts}
                >
                  Update Inventory Counts
                </Button>
              </Col>
            </Row>
            <Row className="rowSpacing cursor pl-2">
              <Col>
                <FilterSet
                  filters={this.state.filters}
                  clearFilters={this.clearFilters}
                  childrenClassName="pt-2 cursor"
                >
                  <Col xs="2">
                    <DateFilter
                      filterName="demandReportDate"
                      displayName="Demand Report Date"
                      onChangeCallback={this.onChangeFilter}
                      value={filterHelper.get_value(
                        "demandReportDate",
                        this.state.filters
                      )}
                    />
                  </Col>
                  <Col xs="2">
                    <TextFilter
                      filterName="productName"
                      displayName="Product Name"
                      descriptionPrefix="contains"
                      onChangeCallback={this.onChangeFilter}
                      value={filterHelper.get_value(
                        "productName",
                        this.state.filters
                      )}
                    />
                  </Col>
                  <Col xs="2">
                    <TextFilter
                      filterName="sku"
                      displayName="Sku"
                      descriptionPrefix="contains"
                      onChangeCallback={this.onChangeFilter}
                      value={filterHelper.get_value("sku", this.state.filters)}
                    />
                  </Col>
                  <Col xs="2">
                    <SelectFilter
                      filterName="productTypeId"
                      displayName="Product Type"
                      isSingleSelect={true}
                      options={this.state.productTypeList}
                      onChangeCallback={this.onChangeFilter}
                      value={filterHelper.getSelectValue(
                        "productTypeId",
                        this.state.filters
                      )}
                    />
                  </Col>
                  <Col xs="2">
                    <ActiveToggleFilter
                      filterName="isThirdPartyProduct"
                      displayName="Third Party Only"
                      onChangeCallback={this.onChangeFilter}
                      value={filterHelper.get_value(
                        "isThirdPartyProduct",
                        this.state.filters
                      )}
                    />
                  </Col>
                </FilterSet>
              </Col>
            </Row>
          </Fragment>
        )}

        <Row>
          {this.state.loading ? (
            <Col className="centerText">
              <FontAwesomeIcon icon="spinner" size="9x" spin className={"cbdmdBlueText"} />
            </Col>
          ) : (
            <Col>
              {this.state.productGroupList &&
                this.state.productGroupList.length > 0 ? (
                  <Fragment>
                    {this.state.pagedList &&
                      this.state.pagedList.list.length > 0 ? (
                        <Table responsive striped>
                          <thead>
                            <tr>
                              <th />
                            </tr>
                          </thead>
                          {this.state.productGroupList.map((group, indx) => (
                            <tbody
                              key={`group-${group.id}${indx}`}
                              className="divider mb-2"
                            >
                              <tr>
                                <td className="product-group-header divider mb-2">
                                  {group.name}
                                  {group.expanded ? (
                                    <FontAwesomeIcon
                                      style={{ float: "right" }}
                                      icon="compress"
                                      title="Collapse Group"
                                      className="expandIcon cursor"
                                      onClick={() => this.onToggleGroup(group.id)}
                                    />
                                  ) : (
                                      <FontAwesomeIcon
                                        style={{ float: "right" }}
                                        icon="bars"
                                        className="expandIcon cursor"
                                        title="Expand Group"
                                        onClick={() => this.onToggleGroup(group.id)}
                                      />
                                    )}
                                </td>
                              </tr>
                              {group.expanded ? (
                                <React.Fragment>
                                  {this.resolveProductDisplayList(
                                    this.state.pagedList.list,
                                    group
                                  ).map((d, index) => (
                                    <tr key={d.productId}>
                                      <td>
                                        {d.expand ? (
                                          <div className="mb-2">
                                            <Col
                                              style={{ width: "10%" }}
                                              className="float-right mt-2"
                                            >
                                              <div className="float-right">
                                                <span className="mr-2">
                                                  <FontAwesomeIcon
                                                    icon="clipboard-list"
                                                    className="cursor addIcon successTealText "
                                                    title="Add to production planning"
                                                    onClick={() =>
                                                      this.onAddToProductionPlanning(
                                                        d.productId
                                                      )
                                                    }
                                                  />
                                                </span>

                                                <FontAwesomeIcon
                                                  icon="compress"
                                                  title="Less Details"
                                                  className="expandIcon cursor"
                                                  onClick={() =>
                                                    this.onToggleExpand(d.productId)
                                                  }
                                                />
                                              </div>
                                            </Col>
                                            <Col style={{ width: "90%" }}>
                                              <ProductionDemandDetails
                                                productData={d}
                                                refresh={this.refreshList}
                                              />
                                            </Col>
                                          </div>
                                        ) : (
                                            <div>
                                              <Row>
                                                <Col xs="10">
                                                  <span className="productTitle">
                                                    {d.productName}
                                                  </span>
                                                  {d.productGroupId === 0 ? (
                                                    <span className="ml-2">
                                                      <FontAwesomeIcon
                                                        icon="exclamation-circle"
                                                        title="Requires group and type association"
                                                        className="warningAlert"
                                                      />
                                                    </span>
                                                  ) : null}
                                                  <ProductSparkline productData={d} />
                                                </Col>
                                                <Col>
                                                  <div className="float-right">
                                                    <span className="mr-2">
                                                      <FontAwesomeIcon
                                                        icon="clipboard-list"
                                                        className="cursor addIcon successTealText "
                                                        title="Add to production planning"
                                                        onClick={() =>
                                                          this.onAddToProductionPlanning(
                                                            d.productId
                                                          )
                                                        }
                                                      />
                                                    </span>
                                                    <span>
                                                      <FontAwesomeIcon
                                                        icon="bars"
                                                        className="expandIcon cursor"
                                                        title="More Details"
                                                        onClick={() =>
                                                          this.onToggleExpand(
                                                            d.productId
                                                          )
                                                        }
                                                      />
                                                    </span>
                                                  </div>
                                                </Col>
                                              </Row>
                                            </div>
                                          )}
                                      </td>
                                    </tr>
                                  ))}
                                  {this.resolveProductDisplayList(
                                    this.state.pagedList.list,
                                    group
                                  ).length > 0 ? (
                                      <tr className="dividerTR mb-2" />
                                    ) : null}
                                </React.Fragment>
                              ) : null}
                            </tbody>
                          ))}
                        </Table>
                      ) : <Table responsive striped><tr><td>No Results Found</td></tr></Table>}
                  </Fragment>
                ) : (
                  <div className="detailText centerText mt-3">
                    <span className="text-warning mr-2">
                      {" "}
                      <FontAwesomeIcon icon="exclamation-circle" />
                    </span>
                    <span>
                      Product Groups have not been created and are required to
                      generate daily demand report. To create product groups please
                      use the admin screens.
              </span>
                  </div>
                )}
              {/*<Pager {...this.state.pagedList} callBack={this.setPage} />*/}
            </Col>
          )}
        </Row>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ProductionDemandReport.js